import LineStyleOptions from './LineStyleOptions';

export default LineStyleOptions;